import { useEffect, useState } from 'react'
import { Box, Button, makeStyles, Tab } from '@material-ui/core'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import allEndorsements from 'src/assets/images/allEndorsements.png'
import { Tooltip } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import AllProducts from 'src/components/Individual/AllProducts'
import AllRenew from 'src/components/Individual/AllRenew'
import AllClaims from 'src/components/Individual/AllClaims'
import AllEndorsements from 'src/components/Individual/AllEndorsements'
import {
  DASHBOARD_TABS,
  SXP_UPLOAD_POLICY_TYPE,
} from 'src/utils/constants/common'
import {
  isCorporateAdmin,
  isCorporateCeo,
  isCorporateLeader,
} from 'src/utils/commonMethods'
import ValueAddedServices from 'src/components/Individual/AddedServices/ValueAddedServices'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import MyPolicyDetails from 'src/components/Individual/MyPoliciesView/MyPolicyDetails'
import BuyPolicyTab from 'src/components/Individual/BuyPolicyTab'
import ClaimAssureGuard from 'src/components/Individual/ClaimAssureGuard'
import LinkedCompanies from 'src/components/common/LinkedCompanies'
import { GET_LINKED_COMPANIES } from 'src/services/corporateService'
import { useQuery } from '@apollo/client'

const PolicyDashboardTabs = () => {
  const classes = useStyles()
  const { userInfo } = useSelector((state) => {
    return {
      userInfo: state?.userInfo,
    }
  })

  const [selectedTab, setSelectedTab] = useState(DASHBOARD_TABS?.YOUR_POLICIES)
  const [childOptions, setChildOptions] = useState([])

  let clientType = userInfo?.userInfo?.userData?.policyHolderType

  const getTabs = () => {
    // if (!isCorporatePOC(userInfo.userInfo.userData.roles)) {
    //   dashboardTabs.splice(0, 0, DASHBOARD_TABS.YOUR_POLICIES);
    // } future devlopment

    return [
      DASHBOARD_TABS?.YOUR_POLICIES,
      DASHBOARD_TABS?.BUYPOLICY,
      DASHBOARD_TABS?.VALUE_ADDED_SERVICES,
      DASHBOARD_TABS?.MODIFICATIONS,
      DASHBOARD_TABS?.CLAIM_ASSUREGUARD,
    ]
  }

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  const getTabName = (tabName) => {
    switch (tabName) {
      case DASHBOARD_TABS?.YOUR_POLICIES:
        return (
          <div id='yourPolicies' className={classes.mainTab}>
            My Policies
          </div>
        )
      case DASHBOARD_TABS?.CLAIM_ASSUREGUARD:
        return (
          <div id='claimAssureGuard' className={classes.mainTab}>
            Claim AssureGuard
          </div>
        )
      case DASHBOARD_TABS?.BUYPOLICY:
        return <div className={classes.buyPolicy}>Buy Policies</div>
      case DASHBOARD_TABS?.PRODUCTS:
        return <div>Products</div>
      case DASHBOARD_TABS?.RENEW:
        return <div>Renew</div>
      case DASHBOARD_TABS?.CLAIM:
        return <div>Claim</div>
      case DASHBOARD_TABS?.VALUE_ADDED_SERVICES:
        return <div className={classes.mainTab}>Value-Added Services</div>
      case DASHBOARD_TABS?.MODIFICATIONS:
        return (
          <div className={classes.mainTab}>
            Policy Additions / Corrections
            <Tooltip
              placement='bottom'
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: `${COLORS?.WHITE} !important`,
                    color: COLORS?.GREY,
                    maxWidth: 800,
                    maxHeight: 500,
                    fontSize: '11px',
                    padding: '20px',
                    boxShadow: ' 10px 10px 30px  rgba(0, 0, 0, 0.7)',
                    borderRadius: '10px',
                  },
                },
                arrow: {
                  sx: {
                    color: `${COLORS?.WHITE} !important`,
                  },
                },
              }}
              title={
                <>
                  <div className='flex'>
                    <img
                      src={allEndorsements}
                      className={classes.endorsementImage}
                      alt='Endorsements'
                    />

                    <div>
                      <p className={classes.endorsementQuestion}>
                        What is an Endorsement (Modification)?
                      </p>
                      <p className={classes.endorsementText}>
                        Any kind of change to a policy is called an endorsement.
                        These changes can include name corrections, KYC updates,
                        family member addition/deletion details, and various
                        modifications. These endorsements are subject to the
                        insurance company&apos;s approval based on policy
                        conditions.
                      </p>
                    </div>
                  </div>
                </>
              }
              arrow
            >
              <InfoOutlinedIcon
                sx={{
                  color:
                    selectedTab === DASHBOARD_TABS?.MODIFICATIONS
                      ? COLORS?.DARK_PINK
                      : COLORS?.WHITE,
                }}
                className={classes.moreInfoIcon}
              />
            </Tooltip>
          </div>
        )
      default:
        return null
    }
  }

  const getTabComponents = (tabName) => {
    switch (tabName) {
      case DASHBOARD_TABS?.YOUR_POLICIES:
        return (
          <MyPolicyDetails
            clientId={userInfo?.userInfo?.userData?.mobileNumber}
            companyName={userInfo?.userInfo?.userData?.clientId}
            clientType={clientType}
            userData={userInfo?.userInfo?.userData}
          />
        )
      case DASHBOARD_TABS?.CLAIM_ASSUREGUARD:
        return (
          <ClaimAssureGuard
            clientId={userInfo?.userInfo?.userData?.clientId}
            emailId={userInfo?.userInfo?.userData?.emailId}
          />
        )
      case DASHBOARD_TABS?.BUYPOLICY:
        return <BuyPolicyTab />
      case DASHBOARD_TABS?.PRODUCTS:
        return <AllProducts />
      case DASHBOARD_TABS?.RENEW:
        return <AllRenew />
      case DASHBOARD_TABS?.CLAIM:
        return <AllClaims />
      case DASHBOARD_TABS?.VALUE_ADDED_SERVICES:
        return <ValueAddedServices />
      case DASHBOARD_TABS?.MODIFICATIONS:
        return (
          <AllEndorsements
            clientType={clientType}
            policyType={SXP_UPLOAD_POLICY_TYPE?.PERSONAL}
          />
        )
      default:
        return null
    }
  }

  const showButtonsContainer = () => {
    const roles = userInfo?.userInfo?.userData?.roles
    return (
      isCorporateLeader(roles) ||
      isCorporateCeo(roles) ||
      isCorporateAdmin(roles)
    )
  }

  const showCompanyPoliciesButton = () => {
    const roles = userInfo?.userInfo?.userData?.roles
    return isCorporateCeo(roles) || isCorporateAdmin(roles)
  }

  const { data: linkedCompaniesData } = useQuery(GET_LINKED_COMPANIES(), {
    variables: {
      clientId:
        userInfo?.userInfo?.userData?.parentClientId ||
        userInfo?.userInfo?.userData?.clientId,
    },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const childCompaniesList =
    linkedCompaniesData?.getChildAndParentCompanyDetails
      ?.childCompanyDetailsList

  useEffect(() => {
    setChildOptions(childCompaniesList)
    // eslint-disable-next-line
  }, [linkedCompaniesData])

  return (
    <div>
      <div className={classes.root}>
        {showButtonsContainer() ? (
          <div className={classes.policyButtonsContainer}>
            {isCorporateLeader(userInfo?.userInfo?.userData?.roles) && (
              <Link
                className={classes.linkStyles}
                to={'/individual/dashboard/'}
                // onClick={addPolicy}
              >
                <Button
                  className={classes.buttonUploadPersonal}
                  // onClick={addPolicy}
                >
                  Leadership Dashboard
                </Button>
              </Link>
            )}
            {showCompanyPoliciesButton() ? (
              <div className={classes.companyPoliciesBtn}>
                <Link
                  className={classes.linkStyles}
                  to={'/individual/dashboard/company'}
                >
                  <Button className={classes.policyButton}>
                    Company Policies
                  </Button>
                </Link>
              </div>
            ) : null}
            {!isCorporateLeader(userInfo?.userInfo?.userData?.roles) && (
              <LinkedCompanies childOptions={childOptions} />
            )}
          </div>
        ) : null}
        <Box className={classes.boxContainer}>
          <TabContext value={selectedTab}>
            <Box>
              <TabList
                id='tabList'
                onChange={handleTabChange}
                className={classes.tabListClass}
                variant='scrollable'
              >
                {getTabs()?.map((tabListItem) => (
                  <Tab
                    key={`tab_${tabListItem}`}
                    label={getTabName(tabListItem)}
                    value={tabListItem}
                    wrapped
                    className={
                      selectedTab === tabListItem ? 'tab-selected' : 'tab'
                    }
                  />
                ))}
              </TabList>
            </Box>
            <>
              {getTabs()?.map((tabListItem) => (
                <TabPanel
                  key={`tabPanel_${tabListItem}`}
                  value={tabListItem}
                  className={'tab-panel'}
                >
                  {getTabComponents(tabListItem)}
                </TabPanel>
              ))}
            </>
          </TabContext>
        </Box>
      </div>
    </div>
  )
}

export default PolicyDashboardTabs

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    gap: '10px',
  },
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.MEDIUM_LIGHTBLUE,
    color: COLORS.WHITE,
    margin: '0px',
    height: '24px',
    padding: '0px 10px',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_LIGHTBLUE,
    },
  },
  policyButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  tabListClass: {
    '& .MuiTabs-flexContainer': {
      gap: '10px',
    },
  },
  policyButton: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.DARK_PINK,
    color: COLORS.WHITE,
    margin: '0px',
    height: '24px',
    padding: '0px 10px',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: COLORS.DARK_PINK,
    },
  },
  linkStyles: {
    textDecoration: 'None',
    color: COLORS?.MEDIUM_BLUE,
  },
  policyTooltipContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    // overflowY: 'scroll',
  },
  policyKey: {
    height: '16px',
    fontSize: '14px',
    fontWeight: '400',
    color: COLORS.GREY,
    textAlign: 'right',
  },
  policyTooltipValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: COLORS.LINK_COLOR_DARK,
    padding: '10px',
  },
  moreInfoIcon: {
    verticalAlign: 'middle',
    marginLeft: '3px',
    width: '18px',
  },
  boxContainer: {
    height: 'fit-content',
  },
  endorsementImage: {
    width: '35%',
  },
  endorsementQuestion: {
    margin: '0px 0px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  endorsementText: {
    margin: '0px 0px',
    fontSize: '13px',
    paddingTop: '20px',
  },
  yourPolicyTooltipContainer: {
    height: '300px',
    overflowY: 'scroll',
  },
  companyName: {
    color: COLORS.DARK_PINK,
  },
  mainTab: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '16.41px',
  },
  companyPoliciesBtn: {
    display: 'flex',
    alignItems: 'center',
  },
})
